import type { Cashier } from '@/hooks/use-employees';

/**
 * VL-351: whether Back Office may change this cashier. A cashier the store
 * system owns (`managedBy` set) is read-only: the API refuses every change to
 * it with 409 `IMPORTED_READ_ONLY`, so the page disables the controls instead
 * of offering them. A response from a host before VL-351 has no `managedBy`
 * and stays editable, as it was.
 */
export function isCashierEditable(cashier: Pick<Cashier, 'managedBy'>): boolean {
  return cashier.managedBy === undefined || cashier.managedBy === null;
}
